import { render, staticRenderFns } from "./activityClass.vue?vue&type=template&id=d25bece6&scoped=true"
import script from "./activityClass.vue?vue&type=script&lang=js"
export * from "./activityClass.vue?vue&type=script&lang=js"
import style0 from "./activityClass.vue?vue&type=style&index=0&id=d25bece6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25bece6",
  null
  
)

export default component.exports